"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateError = exports.messages = void 0;
const react_intl_1 = require("react-intl");
exports.messages = (0, react_intl_1.defineMessages)({
    required: {
        id: 'components/Validation:required',
        defaultMessage: 'Mandatory field.',
    },
    email: {
        id: 'components/Validation:email',
        defaultMessage: 'Value should be a valid email address.',
    },
    url: {
        id: 'components/Validation:url',
        defaultMessage: 'Please enter a valid URL.',
    },
    minLength: {
        id: 'components/Validation:minLength',
        defaultMessage: 'Value must be at least {length} characters long.',
    },
    number: {
        id: 'components/Validation:number',
        defaultMessage: 'Please enter a number.',
    },
    numberRounded: {
        id: 'components/Validation:numberRounded',
        defaultMessage: 'Value should be rounded to 5 centime',
    },
    numberInteger: {
        id: 'components/Validation:integer',
        defaultMessage: 'Please enter a integer.',
    },
    numberPositive: {
        id: 'components/Validation:numberPositive',
        defaultMessage: 'Can\'t be negative',
    },
    numberWithoutZero: {
        id: 'components/Validation:numberWithoutZero',
        defaultMessage: 'Can\'t be zero',
    },
});
const translateError = (formatMessage, issue, ctx) => {
    if (issue.code === 'invalid_type') {
        if (issue.received === 'undefined')
            return formatMessage(exports.messages.required);
        if (issue.expected === 'number')
            return formatMessage(exports.messages.number);
        if (issue.expected === 'integer')
            return formatMessage(exports.messages.numberInteger);
    }
    if (issue.code === 'not_multiple_of') {
        if (issue.multipleOf === 0.05)
            return formatMessage(exports.messages.numberRounded);
    }
    if (issue.code === 'too_small') {
        if (issue.type === 'string')
            return formatMessage(exports.messages.minLength, { length: `${issue.minimum}` });
        if (issue.type === 'number' && issue.minimum === 0 && ctx.data === 0)
            return formatMessage(exports.messages.numberWithoutZero);
        if (issue.type === 'number' && issue.minimum === 0)
            return formatMessage(exports.messages.numberPositive);
    }
    if (issue.code === 'invalid_string') {
        if (issue.validation === 'email')
            return formatMessage(exports.messages.email);
        if (issue.validation === 'url')
            return formatMessage(exports.messages.url);
    }
    return ctx.defaultError;
};
exports.translateError = translateError;
//# sourceMappingURL=translation.js.map